module.exports = function(){




    $(document).on('click', '[js-psr-modal-trigger]',function(event) {
        var data = JSON.parse($(this).attr('js-psr-modal-trigger'));
        var first_name = data.first_name;
        var psr_post_id = data.psr_post_id;

        //window.ephPSRCurrentForm = data;
        $('[js-psr-form-post-id]').val(psr_post_id);
        $('[js-psr-form-first-name]').text(first_name);
    });




    if ( $('[js-psr-contact-form]').length ) {
        $('[js-psr-contact-form]').parsley();
    }



    $('[js-psr-contact-form]').on('submit', function(event) {
        event.preventDefault();

        var $form = $(this);

        if ( $form.parsley().isValid() ) {

            $form.find('button[type="submit"]').prop('disabled', true);
            $form.find('button[type="submit"]').text('Sending...');

            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                error: function(jqXHR, textStatus, errorThrown){
                    $form.find('[js-form-callback]')
                    .text(JSON.parse(jqXHR.responseText).text)
                    .addClass('is-visible')
                    .removeClass('is-success')
                    .addClass('is-error');

                    $form.find('button[type="submit"]').prop('disabled', false);
                    $form.find('button[type="submit"]').text('Retry submitting form');

                },
                success: function(data, textStatus, jqXHR){
                    $form.find('[js-form-callback]')
                    .text('Thanks! Your message has been successfully passed on to our team and you are one step closer to the best fitting clothes you’ve ever had. Your rep should get back to you within 1-2 business days, if you have further questions or need an urgent response please contact support@ephapparel.com')
                    .addClass('is-visible')
                    .removeClass('is-error')
                    .addClass('is-success');
                    $form.find('button[type="submit"]').text('Form submitted succesffully!');
                },
            });

        }


    });







}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/form-psr-contact.js